import resolveRTC from './resolveRTC';

const resolveRichTextContent = ({ rawVal }: any): RichTextContentType => {
  const { rte, visibility } = rawVal || {};
  return {
    rtc: resolveRTC({ rawVal: rte }),
    visibility,
  };
};

export default resolveRichTextContent;
